import { render, staticRenderFns } from "./PriceMinAndMax.vue?vue&type=template&id=335aa524&"
import script from "./PriceMinAndMax.vue?vue&type=script&lang=js&"
export * from "./PriceMinAndMax.vue?vue&type=script&lang=js&"
import style0 from "./PriceMinAndMax.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports